/**
 * Alerta
 * @author Simpli CLI generator
 */
import {$, HttpBody, ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import AlertaSchema from '@/schema/Alerta.schema'
import Responsavel from '@/model/resource/Responsavel'

export default class Alerta extends Resource {

  get $schema() {
    return AlertaSchema(this)
  }

  get $id() {
    return this.idAlertaPk
  }
  set $id(val: ID) {
    this.idAlertaPk = val
  }

  get idReponsavelFk() {
    return this.responsavel!.idResponsavelPk
  }
  set idResponsavelFk(value: ID) {
    this.responsavel!.idResponsavelPk = value
  }

  static async persistLoteAlerta(listToPersist: Alerta[], spinner = 'persistLoteAlerta') {
    const fetch = async () => {
      return await new HttpBody(Number).POST(`/user/lote-alerta`, listToPersist)
    }

    return await $.await.run(fetch, spinner)
  }
  readonly $name: string = 'Alerta'

  readonly $endpoint: string = '/user/alerta{/id}'

  idAlertaPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(255)
  descricao: string = ''

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  ativo: boolean | null = null

  async persistAlerta(spinner = 'persistAlerta') {
    const fetch = async () => {
      await this.validate()
      return await this.POST(`/user/alerta`, this)
    }

    return await $.await.run(fetch, spinner)
  }

  async getAlerta(id: number | string, spinner = 'getAlerta') {
    const fetch = async () => await this.GET(`/user/alerta/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async removeAlerta(id: number, spinner = 'removeAlerta') {
    const fetch = async () => await this.DELETE(`/user/alerta/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
